import { AxiosPromise } from 'axios';
import request from '@/utils/request';

import { SquadListQuery, FifaSquadVo, FormationDetailQuery, FifaSquadDataDetailVo } from './type';

/**
 * 查询Squad列表
  GET /product/api/fifa/squad/list
  接口ID：251633977
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-251633977
 */
export const getSquadList = (params: SquadListQuery): AxiosPromise<FifaSquadVo[]> => {
  return request({
    url: '/product/api/fifa/squad/list',
    method: 'get',
    params
  });
};

/**
 * 查询Squad详情
  GET /product/api/fifa/squad/detail
  接口ID：251683811
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-251683811
 * @param params 
 * @returns 
 */
export const getFormationDetail = (params: FormationDetailQuery): AxiosPromise<FifaSquadDataDetailVo> => {
  return request({
    url: '/product/api/fifa/squad/detail',
    method: 'get',
    params
  });
};

/**
 * 
 * @param params 查询Squad的 formation列表
  GET /product/api/fifa/squad/formation/list
  接口ID：251653570
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-251653570
 * @returns 
 */
export const getFormationList = (): AxiosPromise<string[]> => {
  return request({
    url: '/product/api/fifa/squad/formation/list',
    method: 'get'
  });
};
